export default {"src":"/_next/static/media/right.1a48952b.svg","height":159,"width":139,"blurWidth":0,"blurHeight":0};